import React from 'react'
import Container from '../../../../../components/Container'
import { FormRoles } from '../components/Form'
import { nameActions } from '../domain/info'
import { breadcrumbCreate } from '../domain/breadcrumb'
import { toolsCreate } from '../domain/tools/create'

const RolesCreate = (): JSX.Element => (
  <Container
    pageTitle={nameActions.create.name}
    breadcrumb={breadcrumbCreate}
    tools={toolsCreate}
  >
    <FormRoles typeForm="create" />
  </Container>
)

export default RolesCreate
